
/// <amd-module name="Search/Shared/Components/NotificationArea/index" />
export * from "./NotificationArea";
export * from "./NotificationArea.Props";
